module.exports = __webpack_public_path__ + "static/media/f_hairstyle_straight_long_back.0b81bbc9.png";